'use client'

import { createContext, useContext } from 'react'

const InsightsContext = createContext<{ query?: string }>({
  query: undefined,
})

export function useInsightsContext() {
  return useContext(InsightsContext)
}

export function InsightsContextProvider({
  children,
  query,
}: {
  children: React.ReactNode
  query?: string
}) {
  return (
    <InsightsContext.Provider value={{ query }}>
      {children}
    </InsightsContext.Provider>
  )
}
